module.exports = __webpack_public_path__ + "static/img/1.54a2847.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner/1.jpg
// module id = ht1W
// module chunks = 1